import React from 'react';
import { TextInput } from '@olxui/core/dist/core/TextInput';
import { TestId } from '~testId';
import {
    NoteProgress,
    StyledFormControl,
    StyledP3,
    Wrapper
} from '~components/AdServiceBooking/BookingAdditionalInformation/BookingAdditionalInformation.components';
import { FIELD_NAME_NOTE } from '~components/AdServiceBooking/BookingCalendar';
import { useIntl } from '@olxpwa-lib/i18n/client';
import { useFormContext } from 'react-hook-form';
import { BookingCalendarFormValue } from '~components/AdServiceBooking/types';
import { MAX_NOTE_LENGTH } from '../validation/schemas';

export const BookingAdditionalInformation = () => {
    const { formatMessage } = useIntl();
    const {
        watch,
        register,
        setValue,
        formState: { errors }
    } = useFormContext<BookingCalendarFormValue>();

    const note = watch('note');
    const noteField = register('note');
    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.currentTarget.blur();
        }
    };

    const handleClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue('note', event.target.value, {
            shouldValidate: true
        });
    };

    return (
        <Wrapper>
            <StyledP3>
                {formatMessage({
                    id: 'service.booking.ad.note.label',
                    defaultMessage: 'Additional information (optional)'
                })}
            </StyledP3>
            <StyledFormControl
                inputComponent={TextInput}
                inputProps={{
                    placeholder: formatMessage({
                        id: 'service.booking.ad.note.placeholder',
                        defaultMessage: 'Add note'
                    }),
                    type: 'text',
                    validationStatus: errors[FIELD_NAME_NOTE] && 'hasError',
                    onKeyDown: handleKeyPress,
                    dataAttributes: {
                        testid: TestId.bookingCalendarNotes
                    },
                    ...noteField,
                    //@ts-expect-error Generic types are not passed properly
                    onChange: handleClick
                }}
                error={
                    !!errors[FIELD_NAME_NOTE]
                        ? formatMessage({
                              id: 'service.booking.ad.note.input.max.length',
                              defaultMessage:
                                  'You can only enter up to 180 characters'
                          })
                        : undefined
                }
            />
            {!errors[FIELD_NAME_NOTE] && (
                <NoteProgress>
                    {note?.length || 0}/{MAX_NOTE_LENGTH}
                </NoteProgress>
            )}
        </Wrapper>
    );
};
